import {
  Box,
  Button,
  Container,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import ambassadorHOC from "../../../ambassadors/ambassador-hoc";
import { compose } from "redux";
import { useState } from "react";
import { useBlockedDates } from "../../../../hooks/useBlockedDates";
import { AutoSelectbox } from "../../../../components/selectbox/autoselect";
import { ENUM_AUTOSELECT_LIST_TYPES } from "../../../../enums";
import { getAmbassadorsListFromSearch } from "../../../../apis/ambassadors.api";
import { useDispatch, useSelector } from "react-redux";
import { convertToFullName } from "../../../../services/utils";
import { AppDatePicker } from "../../../../components/datepickers";
import {
  DATE_FORMATS,
  convertToTimezone,
} from "../../../../services/date-and-time.utils";
import { submitManualMeeting } from "../../../../apis/clients.api";

function ClientManualMeeting() {
  const [selectedAmbassador, setSelectedAmbassador]: any = useState();
  const [selectedSlotTimeFrom, setSelectedSlotTimeFrom]: any = useState();
  const [anbassadorList, setAmbassadorList] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);
  const { blockedDates, onMonthChange } = useBlockedDates();
  const clientId = useSelector(
    (state: any) => state?.clients?.selectedClient?.id
  );
  const dispatch = useDispatch();

  function convertToAmbassadorTimezone(date, timezone) {
    const to = new Date(date?.getTime() + 45 * 60000);
    return {
      selectedSlotTimeFrom: date,
      selectedSlotTimeTo: to,
      convertedSlotTimeFrom: convertToTimezone(
        date,
        timezone,
        DATE_FORMATS.fullDateWithTime
      ),
      convertedSlotTimeTo: convertToTimezone(
        to,
        timezone,
        DATE_FORMATS.fullDateWithTime
      ),
    };
  }

  const handleOnChange = async (e) => {
    const text = e?.target?.value;

    if (typeof text === "object") {
      setSelectedAmbassador(text);
      setSelectedSlotTimeFrom();
    }

    const res: any = await dispatch(getAmbassadorsListFromSearch(text));

    if (res.success) {
      const list = res?.data?.map((r) => {
        return {
          fullName: convertToFullName(r?.firstName, r?.lastName),
          id: r?.id,
          timezone: r?.timezone,
        };
      });
      setAmbassadorList(list);
    }
  };

  const handleDateChange = ({ date, timezone }) => {
    const selectedDatetime: any = convertToAmbassadorTimezone(date, timezone);

    setSelectedSlotTimeFrom(selectedDatetime);
  };

  const handleScheduleClick = async () => {
    const payload = {
      clientId: clientId,
      ambassadorId: selectedAmbassador?.id,
      timeSlot: {
        from: selectedSlotTimeFrom?.selectedSlotTimeFrom,
        to: selectedSlotTimeFrom?.selectedSlotTimeTo,
      },
    };

    const response: any = await dispatch(submitManualMeeting(payload));

    if (response?.success) {
      setForceUpdate(true);
      setSelectedAmbassador("");
      setSelectedSlotTimeFrom();
      setForceUpdate(false);
    }
  };

  if (forceUpdate) return null;

  return (
    <Box
      component={Paper}
      p={3}
      sx={{ borderRadius: 2, boxShadow: 3 }}
      maxWidth={450}
    >
      <Typography variant="h6" fontWeight={600}>
        Schedule Manual Meeting
      </Typography>
      <Typography
        component={"span"}
        fontSize={12}
        color="text.secondary"
        mb={2}
      >
        Choose an ambassador and pick a date & time to schedule a meeting.
      </Typography>
      <Divider />

      <Stack mt={2} gap={1}>
        <AutoSelectbox
          label={"Search Ambassador"}
          fullWidth={true}
          field={"ambassadorList"}
          id={"ambassadorList"}
          inlineLabel={false}
          textfieldStyle={{ height: 6, width: "100%" as any }}
          list={anbassadorList || []}
          onChange={handleOnChange}
          value={selectedAmbassador}
          error={""}
          listProperties={{
            field: "fullName",
            value: "id",
          }}
          listType={ENUM_AUTOSELECT_LIST_TYPES.ARRAY_OF_OBJECT}
          requireOnChange={true}
        />

        <Typography fontSize={14}>Select Date & Time</Typography>
        <AppDatePicker
          dateFormat={"Pp"}
          showTimeSelect
          selectedDate={selectedSlotTimeFrom?.selectedSlotTimeFrom}
          setDate={(date) =>
            handleDateChange({
              date,
              timezone: selectedAmbassador?.timezone?.value,
            })
          }
          minDate={new Date()}
          blockedDates={blockedDates}
          onMonthChange={onMonthChange}
        />

        <Box
          sx={{
            bgcolor: "#F7F8FA",
            borderRadius: 1,
            p: 1.5,
            visibility:
              selectedSlotTimeFrom && selectedAmbassador ? "visible" : "hidden",
          }}
        >
          <Typography variant="caption" color="text.secondary">
            Ambassador time
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            {selectedSlotTimeFrom
              ? `${selectedSlotTimeFrom?.convertedSlotTimeFrom} - ${selectedSlotTimeFrom?.convertedSlotTimeTo}`
              : "Not selected"}
          </Typography>
        </Box>

        <Button
          variant="contained"
          fullWidth
          disabled={!selectedAmbassador || !selectedSlotTimeFrom}
          onClick={handleScheduleClick}
        >
          Schedule
        </Button>
      </Stack>
    </Box>
  );
}

export default compose(ambassadorHOC)(ClientManualMeeting);
